const base_version = '';
const base_dev_version = '';
module.exports = {
  dev: {
    imageCdnPath: 'https://image-resource-dev.mastergo.com/',
    cmsCdnPath: 'https://cms-resource-dev.mastergo.com',
    filePreviewPath: `https://dev.mastergo.com${base_dev_version}/files/preview/resource/`,
    protoPath: `https://dev.mastergo.com${base_dev_version}/files/preview/prototype/`,
    file_host: 'https://dev.mastergo.com',
    host: 'https://dev.mastergo.com',
    router_host: 'https://dev.mastergo.com',
    website_host: 'https://dev.mastergo.com',
    oss_bucket: 'mastergo-dev-front',
    proxy_api: {
      root_api: 'https://mastergo.com',
      community_api: 'https://mastergo.com',
      admin_api: 'https://mastergo.com',
    },
    developers: 'https://developers.mastergo.com',
  },
  pre: {
    imageCdnPath: 'https://image-resource-pre.mastergo.com/',
    cmsCdnPath: 'https://cms-resource.mastergo.com',
    filePreviewPath: `https://pre.mastergo.com${base_version}/files/preview/resource/`,
    protoPath: `https://pre.mastergo.com${base_version}/files/preview/prototype/`,
    file_host: 'https://pre.mastergo.com',
    host: 'https://pre.mastergo.com',
    router_host: 'https://pre.mastergo.com',
    proxy: {},
    website_host: 'https://pre.mastergo.com',
    oss_bucket: 'mastergo-pre-front',
    proxy_api: {
      root_api: 'http://lem:8080',
      community_api: 'http://backend-community:8080',
      admin_api: 'http://backend-operation-audit:8080',
    },
    developers: 'https://developers.mastergo.com',
  },
  prod: {
    imageCdnPath: 'https://image-resource.mastergo.com/',
    cmsCdnPath: 'https://cms-resource.mastergo.com',
    filePreviewPath: `https://mastergo.com${base_version}/files/preview/resource/`,
    protoPath: `https://mastergo.com${base_version}/files/preview/prototype/`,
    file_host: 'https://mastergo.com',
    host: 'https://mastergo.com',
    router_host: 'https://mastergo.com',
    website_host: 'https://mastergo.com',
    oss_bucket: 'mastergo-prod-front',
    proxy: {},
    proxy_api: {
      root_api: 'http://lem:8080',
      community_api: 'http://backend-community:8080',
      admin_api: 'http://backend-operation-audit:8080',
    },
    developers: 'https://developers.mastergo.com',
  },
  native: {
    imageCdnPath: 'https://image-resource-dev.mastergo.com/',
    cmsCdnPath: 'https://cms-resource-dev.mastergo.com',
    filePreviewPath: `https://dev.mastergo.com${base_version}/files/preview/resource/`,
    protoPath: `https://dev.mastergo.com${base_version}/files/preview/prototype/`,
    file_host: 'https://dev.mastergo.com',
    host: '/',
    router_host: 'https://dev.mastergo.com',
    website_host: 'https://dev.mastergo.com',
    oss_bucket: 'mastergo-local-front',
    proxy_api: {
      root_api: 'http://ceshi.mastergo.com',
      community_api: 'http://ceshi.mastergo.com',
      admin_api: 'http://ceshi.mastergo.com',
    },
    developers: 'https://developers.mastergo.com',
  },
  local: {
    imageCdnPath: 'https://image-resource-local.mastergo.com/',
    cmsCdnPath: 'https://cms-resource-dev.mastergo.com',
    filePreviewPath: `https://dev.mastergo.com${base_version}/files/preview/resource/`,
    protoPath: `https://dev.mastergo.com${base_version}/files/preview/prototype/`,
    file_host: 'https://dev.mastergo.com',
    host: 'https://dev.mastergo.com',
    lanhu_host: 'https://zz-test.lanhuapp.com',
    router_host: 'https://dev.mastergo.com',
    website_host: 'https://dev.mastergo.com',
    oss_bucket: 'mastergo-local-front',
    proxy_api: {
      root_api: 'http://lem:8080',
      community_api: 'http://backend-community:8080',
      admin_api: 'http://backend-operation-audit:8080',
    },
    developers: 'https://developers.mastergo.com',
  },
  debug: {
    imageCdnPath: 'https://image-resource-local.mastergo.com/',
    cmsCdnPath: 'https://cms-resource-dev.mastergo.com',
    filePreviewPath: `https://dev.mastergo.com${base_version}/files/preview/resource/`,
    protoPath: `https://dev.mastergo.com${base_version}/files/preview/prototype/`,
    file_host: 'https://dev.mastergo.com',
    host: 'https://dev.mastergo.com',
    lanhu_host: 'https://zz-test.lanhuapp.com',
    router_host: 'https://dev.mastergo.com',
    website_host: 'https://dev.mastergo.com',
    oss_bucket: 'mastergo-local-front',
    proxy_api: {
      root_api: 'http://lem:8080',
      community_api: 'http://backend-community:8080',
      admin_api: 'http://backend-operation-audit:8080',
    },
    developers: 'https://developers.mastergo.com',
  },
  pts: {
    imageCdnPath: 'https://image-resource-pts.mastergo.com/',
    cmsCdnPath: 'https://cms-resource-dev.mastergo.com',
    filePreviewPath: `https://pts.mastergo.com${base_version}/files/preview/resource/`,
    protoPath: `https://pts.mastergo.com${base_version}/files/preview/prototype/`,
    file_host: 'https://pts.mastergo.com',
    host: 'https://pts.mastergo.com',
    router_host: 'https://pts.mastergo.com',
    proxy: {},
    website_host: 'https://pts.mastergo.com',
    oss_bucket: 'mastergo-pts-front',
    proxy_api: {
      root_api: 'http://lem:8080',
      community_api: 'http://backend-community:8080',
      admin_api: 'http://backend-operation-audit:8080',
    },
    developers: 'https://developers.mastergo.com',
  },
};
